import React, { useContext, useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min"
import ReportTable from "../../../templates/ReportTable/ReportTable"
import DateRangeFilter from "../../Reports/Filters/DateRangeFilter/DateRangeFilter"
import Loading from "../../../templates/UI/Loading/Loading"
import useDateRangeFilter from "../../../hooks/useDateRangeFilter"
import callAPI from "../../../helpers/callAPI"
import { SystemMessageContext } from "../../../context/SystemMessageContext"
import moment from "moment"

const ApiIntegrationsHistory = () => {

    const history = useHistory()
    const location = useLocation()
    const [dataLoaded, setDataLoaded] = useState(true)
    const [report, setReport] = useState([])

    document.title = "API Integrations History"

    const { showSystemMessage } = useContext(SystemMessageContext);
    const { initStartDate, initEndDate, selectedStartDate, selectedEndDate, quickDate, handleChangeStart, handleChangeEnd, handleQuickDate } = useDateRangeFilter()

    useEffect(() => {
        getReport()
    }, [location])

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'name',
                accessor: 'name',
                Cell: ({ value }) => <span>{value}</span>
            },
            {
                Header: 'Message',
                accessor: 'message',
                Cell: ({ value }) => <span>{value}</span>
            },
            {
                Header: 'Date',
                accessor: 'db_date',
                Cell: ({ value }) => <span>{moment(value).utc().format('YYYY-MM-DD HH:mm:ss')}</span>
            },
            {
                Header: 'Status',
                accessor: 'status',
                Cell: ({ value }) => <span>{value}</span>
            }
        ]

        return (
            <React.Fragment>
                <ReportTable
                    data={report}
                    columns={columns}
                />
            </React.Fragment>
        )
    }

    const getReport = () => {
        setDataLoaded(false)

        let url = `reports/apiIntegrationsHistory?startDate=${initStartDate}&endDate=${initEndDate}`

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setReport(result.data)
                    setDataLoaded(true)
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                    setDataLoaded(true)
                }
            })
            .catch((error) => {
                console.log(`Error while fetching API integrations history: ${error}`)
                showSystemMessage('error', 'An error occurred while fetching API integrations history')
            })
    }

    const refreshReport = (e) => {
        e.preventDefault()

        let url = `/apiIntegrationsHistory?startDate=${selectedStartDate}&endDate=${selectedEndDate}`

        history.push(url)
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Reports</h1>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    <div className="card">
                        <div>
                            <div className="d-flex justify-content-between">
                                <div className="d-flex p-3">
                                    <div className="mr-4 d-flex allgn-items-center">
                                        <div className="mr-4 d-flex align-items-center">
                                            <h1 className="mb-h1-dark">API Integrations History</h1>
                                        </div>
                                        <React.Fragment>
                                            <DateRangeFilter quickDate={quickDate} selectedStartDate={selectedStartDate} selectedEndDate={selectedEndDate} handleChangeStart={handleChangeStart} handleChangeEnd={handleChangeEnd} handleQuickDate={handleQuickDate} />
                                            <div>
                                                <button onClick={refreshReport} className="btn btn-sm btn-primary">
                                                    Refresh Report
                                                </button>
                                            </div>
                                        </React.Fragment>
                                    </div>
                                </div>
                            </div>
                            {dataLoaded ? report.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading></Loading>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ApiIntegrationsHistory